import React, { useState } from "react";
import Box from "@mui/material/Box";
import Input from "@mui/material/Input";
import styles from "./assets/scss/search.module.scss";

interface SearchBarProps {
  onSearch: (searchTerm: string) => void;
}

const SearchBar = ({ onSearch }: SearchBarProps) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    onSearch(e.target.value.toLowerCase());
  };

  return (
    <Box
      component="form"
      sx={{ "& > :not(style)": { m: 1 } }}
      noValidate
      autoComplete="on"
    >
      <Input
        className={styles.in}
        placeholder="Search"
        value={searchTerm}
        onChange={handleSearchInputChange}
      />
    </Box>
  );
};

export default SearchBar;
